import React from "react";
import { YahooContent } from "../yahoo/YahooContent";

export function AdContent({ page }: { page: string }) {
  // Since this is a temporary fix, we will log the page to the console.
  // This prevent us from removing the page prop in a whole lot of places, making this temp fix bigger than it needs to be
  // eslint-disable-next-line no-console
  console.log("page", page);
  // Temporary fix: show Yahoo content for everything except RSOC with working AdSense
  // TODO: Revert once cashparking customers are migrated to RSOC (after reporting is ready)

  return <YahooContent />;
}
